import { api } from "../../utils";
const cafe = {
    default: {
        sp: {
            chromeSMS: "chrome/runtime/sendMessage",
            chromeRegion: "chrome/region",
            socketEmit: "socket/emit",
        },
        member: {
            MemberName: "Anonymous",
        },
        from: {
            source: "core.es6.vn",
        },
    },
    timeout: {
        loadList: 4000,
        loadRegion: 12000,
    },
    sms: {
        socket: api.sms.socket,
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const df = cafe.default;

const loadListStart = async ({ rootState, state, dispatch, commit }) => {
    let p = new Promise(async (resolve) => {
        console.log("store.supporter.list.start");
        const { tab } = rootState.chrome.runtime;
        const ua = rootState.useragent;
        let socket = rootState.socket.socket;
        let windowId = rootState.chrome.runtime.windowId;
        if (!socket) return resolve({ error: cafe.sms.socket.undefined });
        let port = {
            manifest: {
                name: "chrome.runtime.manifest",
                req: {},
            },
        };
        if (tab.id === -1) {
            let res_manifest = await dispatch(df.sp.chromeSMS, port.manifest, { root: true });
            console.log("res_manifest", res_manifest);
            if (!res_manifest || !res_manifest.is_success) return resolve({ error: res_manifest.error });
            windowId = res_manifest.data.tab.windowId;
        };
        let isWorking = false;
        let ip = await dispatch("loadIP", null, { root: true });
        let mem = ua.member || df.member;
        let from = {
            id: socket.id,
            windowId,
            ip,
            isWorking,
            source: df.from.source,
            name: mem.MemberName,
            href: window.location.href,
            incognito: tab.incognito,
            browser: ua.headers.browser,
            os: ua.headers.os,
            region: null,
        };
        let filter = {
            key: "req.poke",
            to: [],
            data: { from },
        };
        let res_sl = await dispatch("socket/list", null, { root: true });
        if (!res_sl || !res_sl.is_success) return resolve({ error: res_sl.error });
        for (let item of res_sl.data) filter.to.push(item.id);
        if (!filter.to.length) return resolve({ error: cafe.sms.socket.all_busy });
        let res_poke = await dispatch(df.sp.socketEmit, filter, { root: true });
        if (!res_poke || !res_poke.is_success) return res_poke({ error: res_poke.error });
        let data = {
            obj: {},
            list: [],
            tempObj: {},
            statusList: "loading",
            statusRegion: "loading",
        };
        commit({ type: "loadData", data });
        commit("chrome/runtime/loadData", { data: { from } }, { root: true });
        setTimeout(() => {
            if (state.statusList === "done") return;
            console.log("store.supporter.list.force.end");
            dispatch("loadListEnd", state.tempObj);
        }, cafe.timeout.loadList);
        resolve(res_poke);
    });

    return p;
};

const loadListUpdate = async ({ rootState, state, dispatch }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload) return resolve({ error: cafe.sms.invalid_inputs });
        console.log("store.supporter.list.update", payload);
        if (state.statusList === "done") return resolve({ is_success: true, data: state.list });
        let socket = rootState.socket;
        state.tempObj[payload.id] = payload;
        let keys = Object.keys(state.tempObj);
        let m = socket.list.length;
        let n = keys.length;
        if (m == n) {
            console.log("store.supporter.list.done");
            dispatch("loadListEnd", state.tempObj);
        };
        resolve({ is_success: true, data: payload });
    });

    return p;
};

const loadListEnd = async ({ state, commit }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload) return resolve({ error: cafe.sms.invalid_inputs });
        if (state.statusList === "done") return resolve({ is_success: true, data: state.list });
        console.log("store.supporter.list.end", payload);
        let listWindow = [];// list string
        let list = [];
        let obj = {};
        let ids = [];
        let keys = Object.keys(payload);
        for (let id of keys) {
            let item = payload[id];
            const { isWorking, ip, windowId } = item;
            if (isWorking || windowId <= 0) continue;
            let text = `${ip}-${windowId}`;
            if (listWindow.includes(text)) continue;
            listWindow.push(text);
            obj[id] = item;
        };
        keys = Object.keys(obj);
        for (let id of keys) {
            let item = obj[id];
            ids.push(id);
            list.push(item);
        };
        let data = { obj, list, ids, statusList: "done" };
        commit({ type: "loadData", data });
        resolve({ is_success: true, data: list });
    });

    return p;
};

const loadRegionStart = async ({ rootState, state, dispatch, commit }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload || !Array.isArray(payload.to)) return resolve({ error: cafe.sms.invalid_inputs });
        console.log("store.supporter.region.start", payload);
        let socket = rootState.socket.socket;
        let from = rootState.chrome.runtime.from;
        if (!socket) return resolve({ error: cafe.sms.socket.undefined });
        let filter = {
            key: "req.region",
            to: payload.to,
            data: { from },
        };
        let res_socket = await dispatch(df.sp.socketEmit, filter, { root: true });
        let data = {
            tempRegion: [],
            statusRegion: "loading",
        };
        commit({ type: "loadData", data });
        setTimeout(() => {
            if (state.statusRegion === "done") return;
            console.log("store.supporter.region.force.end");
            dispatch("loadRegionEnd", state.tempRegion);
        }, cafe.timeout.loadRegion);
        resolve(res_socket);
    });

    return p;
};

const loadRegionUpdate = async ({ state, dispatch }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload) return resolve({ error: cafe.sms.invalid_inputs });
        console.log("store.supporter.region.update", payload);
        if (state.statusRegion === "done") return resolve({ is_success: true, data: state.list });
        state.tempRegion.push(payload);
        let m = state.list.length;
        let n = state.tempRegion.length;
        if (m == n) {
            console.log("store.region.list.done");
            dispatch("loadRegionEnd", state.tempRegion);
        };
        resolve({ is_success: true, data: payload });
    });

    return p;
};

const loadRegionEnd = async ({ state, commit }, payload) => {
    let p = new Promise(async (resolve) => {
        if (!Array.isArray(payload)) return resolve({ error: cafe.sms.invalid_inputs });
        if (state.statusRegion === "done") return resolve({ is_success: true, data: state.list });
        console.log("store.supporter.region.end", payload);
        let obj = {};
        let list = [];
        let ids = [];
        for (let item of payload) {
            let res = item.payload;
            if (!item.from || !item.from.id) continue;
            if (!res || !res.is_success || !res.data || !res.data.region) continue;
            obj[item.from.id] = item.from;
        };
        let keys = Object.keys(obj);
        for (let [index, id] of keys.entries()) {
            let item = obj[id];
            item.index = index + 1;
            ids.push(id);
            list.push(item);
        };
        let data = { obj, list, ids, statusRegion: "done" };
        commit({ type: "loadData", data });
        resolve({ is_success: true, data: list });
    });

    return p;
};

export default {
    loadListStart,
    loadListUpdate,
    loadListEnd,
    loadRegionStart,
    loadRegionUpdate,
    loadRegionEnd,
};



// WEBPACK FOOTER //
// src/store/supporter/actions.js